<template>
  <v-card>
    <v-card-title class="headline">
      <slot name="title"></slot>
    </v-card-title>
    <v-card-text>
      <slot></slot>
    </v-card-text>
    <v-card-actions class="justify-end">
      <slot name="actions">
        <v-btn
          v-if="!hideBackButton"
          @click="$emit('backAction')"
          title="Back"
          class="mr-auto"
          icon
        >
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-btn @click="$emit('cancelAction')">
          {{ cancelButtonText || 'Cancel' }}
        </v-btn>
        <v-btn
          @click="$emit('nextAction')"
          :disabled="disableNextButton"
          :loading="nextButtonIsLoading"
        >
          {{ nextButtonText || 'Next ' }}
        </v-btn>
      </slot>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'GenericTask',
  props: {
    hideBackButton: Boolean,
    disableNextButton: Boolean,
    cancelButtonText: String,
    nextButtonText: String,
    nextButtonIsLoading: Boolean
  }
};
</script>
